import React from "react";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/api";

export const Logo = ({ showTagline = true, className = "", markOnly = false }) => {
  if (markOnly) {
    return (
      <Link to="/" data-testid="logo-mark" className={`flex items-center ${className}`}>
        <img src={ASSETS.hqMark} alt="Card HQ" className="h-10 w-10 object-contain logo-float" />
      </Link>
    );
  }
  return (
    <Link to="/" data-testid="logo-link" className={`group flex flex-col leading-none ${className}`}>
      <div className="flex items-baseline gap-[2px]">
        <span className="font-display font-black text-2xl tracking-tight text-chrome">
          CARDSCIENCE
        </span>
        <span className="font-display font-black text-2xl tracking-tight text-holo-rainbow">HQ</span>
      </div>
      {showTagline && (
        <span className="font-tech text-[9px] tracking-[0.35em] text-[color:var(--chrome-3)] mt-1">
          CLEAN &bull; RESTORE &bull; PREP &bull; PRESERVE
        </span>
      )}
    </Link>
  );
};
